// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// BUSINESS UNIT SCHEMA
/////////////////////////////////////////

export const BusinessUnitSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  color: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type BusinessUnit = z.infer<typeof BusinessUnitSchema>

export default BusinessUnitSchema;
